import { Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class PrintIDLService {
    isPrinting = false;
    constructor(private router: Router, private activatedRoute: ActivatedRoute) { }
  //printDocument(documentName: string, num: Number) {
  //  alert("print: " + num);
  //  this.isPrinting = true;
  //  this.router.navigate(['/',
  //    {
  //      outlets: {
  //        'print': ['print', documentName ]
  //      }
  //    }]);
  //  }

    printDocument(documentName: string, num: any) {
      alert("printIDL: " + num);
        this.isPrinting = true;  
      this.router.navigate(['/',
        {
          outlets: {
            'printIDL': ['printIDL', documentName, num]
          }
        }]);
        
    }

    onDataReady2() {
        alert("ready to print..");
    //setTimeout(() => {
      window.print();
      this.isPrinting = false;
      this.router.navigate([{ outlets: { printIDL: null } }]);
    //});
  }

}
